<template>
    <div class="setup-list-content">
        <div class="search-container">
            <el-form ref="form" :model="queryParams">
                <el-form-item label="类型：">
                    <el-select v-model="queryParams.type" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="完整视频" value="0"></el-option>
                        <el-option label="合并视频" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-input v-model="queryParams.title" @keypress.native.enter="search" placeholder="请输入视频名称"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="setup-list-container">
            <div class="mg-bottom16">
                <el-button type="primary" size="small" @click="mergeVideo">合并</el-button>
                <el-button type="primary" size="small" @click="mergeTask">合并任务</el-button>
            </div>
            <div class="table-container">
                <el-table :data="tableData" border v-loading="listLoading" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <el-table-column prop="title" label="视频名称" min-width="220"></el-table-column>
                    <el-table-column prop="type" label="类型" min-width="100"></el-table-column>
                    <el-table-column prop="begin_time" label="开始时间" min-width="160"></el-table-column>
                    <el-table-column prop="end_time" label="结束时间" min-width="160"></el-table-column>
                    <el-table-column label="视频时长(分钟)" min-width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.duration | formatDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="140">
                        <template slot-scope="scope">
                            <el-button type="text" size="medium" @click="preview(scope.row)">预览</el-button>
                            <el-button type="text" size="medium" @click="download(scope.row)">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-container text-align-right">
                <div class="table-total">共 <span>{{ tableTotal }}</span> 条</div>
                <!-- <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange" /> -->
            </div>
        </div>
        <div v-if="mergeDialog">
            <el-dialog :title="dialogTitle" :visible.sync="mergeDialog" width="580px" >
                <div class="mergeForm-content">
                    <el-form :model="mergeForm" :rules="mergeRule" ref="mergeForm" label-width="85px" label-position="left" >
                        <el-form-item label="视频名称：" prop="name" >
                            <el-input v-model="mergeForm.name" placeholder="请输入合并后视频名称"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="mergeDialog = false" >取 消</el-button>
                    <el-button type="primary" :loading="loading" size="small" @click="handleMerge">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-if="videoDialog">
            <el-dialog :title="dialogTitle" :visible.sync="videoDialog" width="900px" >
                <video :src="previewVideo" style="background: #000;" width="100%" height="500px" controls></video>
            </el-dialog>
        </div>
        <div v-if="mergeTaskDialog">
            <el-dialog :title="dialogTitle" :visible.sync="mergeTaskDialog" width="600px" >
                <el-table :data="mergeTaskData" border>
                    <el-table-column prop="title" label="视频名" min-width="240"></el-table-column>
                    <el-table-column prop="status" label="任务状态" min-width="160"></el-table-column>
                </el-table>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { getRecord, mergeVideo, mergeTask } from '@/api/live/index'
// import Pagination from '@/components/Pagination'

export default {
    inject: ['reload'],
    name: 'setupList',
    props: [],
    data() {
        return {
            liveId: '',
            listLoading: false,
            loading: false,
            queryParams: {
                // page: 1,
                // per_page: 10
            },
            tableData: [],
            tableTotal: 0,
            pageParams: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            dialogTitle: '',
            mergeDialog: false,
            mergeForm: {
                name: '',
                video_ids: []
            },
            mergeRule: {
                name: [
                    { required: true, message: '合并视频名称不能为空', trigger: 'blur' }
                ]
            },
            videoDialog: false,
            previewVideo: '',
            mergeTaskDialog: false,
            mergeTaskData: []
        }
    },
    components: {
        // Pagination
    },
    filters: {
        formatDate(value) {
            var result = ''
            var time = parseInt(value)
            var hr = parseInt(time / 60 / 60)
            var min = parseInt((time / 60) % 60)
            var sec = parseInt(time % 60)
            hr = hr > 9 ? hr : '0' + hr
            min = min > 9 ? min : '0' + min
            sec = sec > 9 ? sec : '0' + sec
            if (hr !== '00') {
                result = hr + ':' + min + ':' + sec
            } else {
                result = '00:' + min + ':' + sec
            }
            return result
        }
    },
    created() {
        this.liveId = this.$route.query.id
        this.getRecord()
    },
    methods: {
        getRecord() {
            this.listLoading = true
            // this.queryParams.page = this.pageParams.currentPage
            // this.queryParams.per_page = this.pageParams.pageSize
            getRecord(this.queryParams, this.liveId).then(res => {
                if (res.code === 0) {
                    this.tableData = res.data.list
                    this.tableTotal = res.data.total
                    // this.pageParams.total = res.data.total
                }
                this.listLoading = false
            }).catch((res) => {
                this.listLoading = false
            })
        },
        handleSelectionChange(val) {
            var selectList = []
            val.forEach((ele) => {
              selectList.push(ele.id)
            })
            this.mergeForm.video_ids = selectList
        },
        mergeVideo() {
            if (this.mergeForm.video_ids.length === 0) {
                this.$message.error('请选择合并视频')
            } else {
                this.dialogTitle = '视频合并'
                this.mergeDialog = true
            }
        },
        handleMerge() {
            this.$refs['mergeForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    mergeVideo(this.mergeForm, this.liveId).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message.success(res.msg)
                            this.reload()
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        mergeTask() {
            this.dialogTitle = '合并任务'
            mergeTask(this.liveId).then(res => {
                if (res.code === 0) {
                    this.mergeTaskData = res.data.list
                    this.mergeTaskDialog = true
                }
            }).catch(res => {})
        },
        preview(row) {
            this.dialogTitle = '视频预览'
            this.previewVideo = row.url
            this.videoDialog = true
        },
        download(row) {
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = row.url
            link.setAttribute('download', row.title)
            document.body.appendChild(link)
            link.click()
        },
        // 分页
        // pageChange(page) {
        //     this.pageParams.currentPage = page.currentPage
        //     this.pageParams.pageSize = page.pageSize
        //     this.getRecord()
        // },
        search() {
            // this.queryParams.page = 1
            // this.pageParams.currentPage = 1
            this.getRecord()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.setup-list-content{
    .table-container{
        .video-adress{
            color: $primaryColor;
        }
    }
    .table-total {
        font-size: 14px;
        color: #999;
        span {
            color: $primaryColor;
        }
    }
}
.mergeForm-content{
    .el-form-item:last-child{
        margin-bottom: 0;
    }
}
</style>
